import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';

import { USER_INFO_COOKIE_KEY } from '@/constants';
import { UserInfoToken } from '@/models/User';
import { camelizeKeys } from 'humps';

export function getUserInfo(): UserInfoToken | undefined {
  const raw = Cookies.get(USER_INFO_COOKIE_KEY);
  if (!raw) return undefined;
  try {
    const userInfo = camelizeKeys<UserInfoToken>(jwtDecode<UserInfoToken>(raw));
    return userInfo;
  } catch {
    return undefined;
  }
}

export function removeUserInfo(): void {
  Cookies.remove(USER_INFO_COOKIE_KEY);
}
